import "./Journey.module.css";
import Header from "@/reusable_sections/Header";
import GarderenBagTroen from "./sections/GarderenBagTroen";
import FraKaosTilKarakter from "./sections/FraKaosTilKarakter";
import MilitaryValues from "./sections/MilitaryValues";
import Footer from "@/reusable_sections/Footer";
export default function JourneyPage() {
  return <div>
      <Header />
      <GarderenBagTroen />
      <FraKaosTilKarakter />
      <MilitaryValues />
      <Footer />
    </div>;
}